import axios from "axios"
import { BACKEND_BASE_URL } from "./Constants"

/**
 * Create axios instance with interceptors for automatic token refresh
 */
const axiosInstance = axios.create({
	baseURL: BACKEND_BASE_URL,
})

/**
 * Store the auth provider reference
 * This will be set by the AuthProvider component
 */
let auth0Client = null

export const setAuth0Client = (client) => {
	auth0Client = client
}

/**
 * Response interceptor to handle token expiration
 */
axiosInstance.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config

		// Check if error is due to unauthorized access and we haven't already retried
		if (error.response?.status === 401 && !originalRequest._retry && auth0Client) {
			originalRequest._retry = true

			try {
				// Force refresh the access token using Auth0
				const newToken = await auth0Client.getAccessTokenSilently({
					cacheMode: 'off' // Force refresh instead of using cached token
				})

				// Update the authorization header with new token
				originalRequest.headers.Authorization = `Bearer ${newToken}`

				// Retry the original request with new token
				return axiosInstance(originalRequest)
			} catch (refreshError) {
				// If token refresh fails, redirect to login
				console.error('Token refresh failed:', refreshError)

				// Clear any cached tokens and redirect to login
				if (auth0Client.loginWithRedirect) {
					auth0Client.loginWithRedirect({
						appState: { returnTo: window.location.pathname }
					})
				}

				return Promise.reject(refreshError)
			}
		}

		return Promise.reject(error)
	}
)

export default axiosInstance
